import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import logo_mynextID from "../../img/logo_mynextID.svg";
import { useSession } from "../session/Context";
import { useEffect, useContext } from "react";
import { MyContext } from "../../MyContext";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HamburgerMenu from "../header/HamburgerMenu";

interface Navbar {
  notification: number;
}

export const navItemsAuth = [
  {
    id: 1,
    title: "Issued credentials",
    path: "dashboard",
    cName: "",
  },
  {
    id: 2,
    title: "Issue credential",
    path: "create_credential",
    cName: "",
  },
  /*{
    id: 3,
    title: "CREATE TEMPLATE",
    path: "create_template",
    cName: "",
  },
  {
    id: 4,
    title: "CREATE SCHEMA",
    path: "create_schema",
    cName: "",
  },*/
  {
    id: 5,
    title: "Add credential template",
    path: "add_issuance",
    cName: "",
  },
  {
    id: 6,
    title: "Account settings",
    path: "settings",
    cName: "",
  },
];

const Navbar = (props: Navbar) => {
  const {
    status,
    brand,
    error_reason,
    cookie,
    is_admin,
    is_onboarded,
    onboarding,
  } = useSession();

  const { onPage, setOnPage } = useContext(MyContext)!;
  const [open, setOpen] = useState(false);

  let ts: NodeJS.Timeout | undefined;

  // Notification code
  const { notifications } = useSession();

  return (
    <>
      <nav className="navbar">
        <Link to="/">
          <img src="img/logo_mynextID.svg" alt="" className="logo m-show" />
        </Link>

        <div className="navbar__right site-navigation ">
          {is_admin && (
            <>
              <div className="actions ">
                <Link
                  to="/notifications"
                  className="notifications"
                  onClick={() => {
                    setOnPage("/notifications");
                  }}
                >
                  {notifications.length > 0 && (
                    <div className="bubble">{notifications.length}</div>
                  )}
                  <img src="img/bell.svg" alt="Notifications" />
                </Link>
                <HamburgerMenu onPageChange={setOnPage}></HamburgerMenu>
              </div>
            </>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
